module.exports = __webpack_public_path__ + "img/116_thumbnail.94eab352.jpg";